export default "/images/9454b2ad890cd8533e41e6392fe63a44.avif";